var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('b-sidebar', {
    attrs: {
      "id": _vm.id,
      "title": "Informações visíveis",
      "backdrop-variant": "dark",
      "backdrop": "",
      "right": "",
      "shadow": ""
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function fn() {
        return [_c('div', {
          staticClass: "d-flex text-light align-items-center px-3 py-2"
        }, [_c('button', {
          staticClass: "btn btn-primary btn-hover-dark font-weight-bold",
          staticStyle: {
            "width": "100%"
          },
          on: {
            "click": _vm.handleSave
          }
        }, [_vm._v(" Salvar ")])])];
      },
      proxy: true
    }])
  }, [_c('div', {
    staticClass: "px-2 py-2"
  }, [_c('div', {
    staticClass: "p-2",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('h4', {
    staticClass: "text-dark"
  }, [_vm._v("Colunas customizadas")]), _c('p', [_vm._v(" Selecione abaixo quais colunas deseja que estejam visíveis na listagem de " + _vm._s(_vm.moduleLabel) + ". Arraste para definir a ordem. ")])]), _c('div', {
    staticClass: "mb-2",
    staticStyle: {
      "width": "100%",
      "max-height": "100%",
      "overflow-y": "scroll"
    }
  }, [_c('draggable', {
    attrs: {
      "handle": ".drag-handle",
      "animation": 150,
      "ghost-class": "drag-ghost"
    },
    model: {
      value: _vm.localFields,
      callback: function callback($$v) {
        _vm.localFields = $$v;
      },
      expression: "localFields"
    }
  }, _vm._l(_vm.localFields, function (field) {
    return _c('div', {
      key: field.field,
      staticClass: "column-custom-item mb-0 ml-1 mr-1 p-1 rounded"
    }, [_c('div', {
      staticStyle: {
        "display": "flex",
        "align-items": "center",
        "gap": "10px"
      }
    }, [_c('span', {
      staticClass: "drag-handle",
      staticStyle: {
        "cursor": "grab"
      },
      attrs: {
        "title": "Arraste para reordenar"
      }
    }, [_c('DragVertical', {
      staticClass: "text-muted",
      attrs: {
        "size": 20
      }
    })], 1), _c('span', {
      staticClass: "switch switch-icon",
      class: {
        'switch-disabled': _vm.isFieldRequired(field)
      }
    }, [_c('label', [_c('input', {
      attrs: {
        "type": "checkbox",
        "disabled": _vm.isFieldRequired(field)
      },
      domProps: {
        "checked": _vm.isFieldSelected(field.field)
      },
      on: {
        "change": function change($event) {
          return _vm.handleToggleField($event.target.checked, field.field);
        }
      }
    }), _c('span')])]), _c('label', {
      staticClass: "mb-0",
      class: {
        'text-muted font-weight-bold': _vm.isFieldRequired(field)
      }
    }, [_vm._v(" " + _vm._s(field.label) + " ")])])]);
  }), 0)], 1)])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };